// extracted by mini-css-extract-plugin
export var downArrow = "_gp-0";
export var infoTooltipIcon = "_gp-3";
export var label = "_gp-1";
export var optionCard = "_gp-4";
export var upArrow = "_gp-2";